import axios from 'axios'
import { attachAuthRefresh } from './authInterceptor'

// Wave Final (P1-F13): см. http/index.js — в prod ENV должен быть задан.
const fallbackUrl = 'https://sys.chu.kg/api/'
const envUrl = process.env.REACT_APP_API_URL
if (!envUrl && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.error(
    '[CHU] REACT_APP_API_URL не задан в production-сборке (apiJSON).',
  )
}
export const API_URL = envUrl || fallbackUrl

export const $apiJSON = axios.create({
  withCredentials: true,
  baseURL: API_URL,
})

$apiJSON.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 401 → refresh → retry; при провале — clear + redirect /login.
attachAuthRefresh($apiJSON)

export default $apiJSON
